<h1 class="title">
  {{ data?.label }}
  {{ 'monitoring.selection' | translate }}
</h1>

<ng-container *ngIf="dialogFacade.items$ | async">
  <div class="list">
    <div *ngFor="let item of formArray.controls | slice : 0 : numberOfDisplayedItems" class="list__item">
      <mat-checkbox
        [formControl]="item.controls.isSelected"
        class="list__item-checkbox"
        [ngClass]="{ selected: item.controls.isSelected.value }"
      >
        <span class="list__item-text" cropText>
          {{ item.value.value }} |
          {{ item.value.description }}
        </span>
        <ui-svg-icon
          *ngIf="item.controls.isSelected.value"
          class="color-success list__item-checkbox-icon list__item-checkbox-icon__checkmark"
          [name]="iconNameList.Checkmark"
        ></ui-svg-icon>
      </mat-checkbox>
    </div>

    <mat-chip-option
      *ngIf="numberOfDisplayedItems < formArray.controls?.length"
      [selectable]="true"
      class="show-more-btn"
      (click)="numberOfDisplayedItems = formArray.controls?.length"
    >
      {{ 'common.button.showMore' | translate }}...
    </mat-chip-option>
  </div>

  <div class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button [action]="buttonAction.Apply" (buttonClick)="apply()"></ui-action-button>
  </div>
</ng-container>
